import { getRandomRef, StorageItemRefType, uploadFile } from 'util/services/upload'

export const uploadAvatar = async ({ file, formData, mode, refId, storeId }: UploadAvatarProps) => {
  if (!file) return
  const location = await uploadFile({
    file,
    location: `${mode}/avatar`,

    mimeType: file.type,
    originalFileName: file.name,

    storeId,

    refId: String(refId || getRandomRef()),
    refType: {
      user: StorageItemRefType.USER_PROFILE_PICTURE,
      store: StorageItemRefType.STORE_AVATAR,
      contact: StorageItemRefType.CLIENT_PROFILE_PICTURE
    }[mode]
  })

  formData.set('picture', location)
}

export type UploadAvatarProps = {
  file?: File,
  mode: 'store' | 'user' | 'contact'
  formData: FormData,

  refId?: number | string,
  storeId: number,
}
